import { useQuery, UseQueryOptions } from 'react-query';
import { GetSalesforceBundleNameRequest, GetSalesforceBundleNameResponse } from './types';
import { PackageService } from '@weave/schema-gen-ts/dist/schemas/package-service/v1/package.pb';
import { authorizedFetch } from '../../helpers/utils';

export const salesforceQueryKeys = {
  base: ['salesforce'],
  getSalesforceBundleName: ({ locationId }: GetSalesforceBundleNameRequest) => [
    ...salesforceQueryKeys.base,
    'bundle',
    locationId,
  ],
};

export const useGetSalesforceBundleName = <TData = GetSalesforceBundleNameResponse>(
  request: GetSalesforceBundleNameRequest,
  options?: UseQueryOptions<GetSalesforceBundleNameResponse, Error, TData>
) => {
  return useQuery({
    queryKey: salesforceQueryKeys.getSalesforceBundleName(request),
    queryFn: () => PackageService.GetSalesforceBundleName(authorizedFetch(), request),
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });
};
